import { useEffect, useState } from "react";
import { Loader2, Mail, Plus, Send, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Panel } from "./common";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Switch } from "./ui/switch";
import { VigImport } from "./VigImport";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });

function Emails({ list, onChange }) {
  const [v, setV] = useState("");
  const add = () => { const e = v.trim().toLowerCase(); if (!e) return; if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e)) return toast.error("Email non valida"); if (!list.includes(e)) onChange([...list, e]); setV(""); };
  return (
    <div>
      <div className="flex gap-2">
        <Input type="email" value={v} onChange={(e) => setV(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }} placeholder="nome@esempio.it" className="h-10" data-testid="vig-digest-email-input" />
        <Button type="button" variant="outline" onClick={add} className="rounded-full" data-testid="vig-digest-email-add"><Plus className="w-4 h-4 mr-1" />Aggiungi</Button>
      </div>
      <div className="flex flex-wrap gap-2 mt-3" data-testid="vig-digest-emails">
        {list.map((e) => <span key={e} className="inline-flex items-center gap-1 rounded-full bg-[var(--sand,#f4f1ea)] px-3 py-1 text-sm">{e}<button type="button" onClick={() => onChange(list.filter((x) => x !== e))} aria-label="Rimuovi" data-testid={`vig-digest-remove-${e}`}><X className="w-3.5 h-3.5" /></button></span>)}
        {!list.length && <span className="text-sm text-slate-500">Nessun destinatario</span>}
      </div>
    </div>
  );
}

export function VigDigest() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState("");
  const [day, setDay] = useState(today());
  useEffect(() => { api("/local/vig-digest").then(setD).catch(() => setD(false)); }, []);
  if (!d) return null;
  const c = d.config;
  const set = (k, v) => setD({ ...d, config: { ...c, [k]: v } });
  const run = async (k, fn) => { setBusy(k); try { await fn(); } catch (e) { toast.error(e.message); } finally { setBusy(""); } };
  const save = () => run("save", async () => { const r = await api("/local/vig-digest", { method: "PUT", body: c }); setD({ ...d, config: r.config }); toast.success("Impostazioni salvate"); });
  const send = () => run("send", async () => { const r = await api("/local/vig-digest/send", { method: "POST", body: { data: day } }); toast.success(`Riepilogo inviato a ${r.sent} destinatari (${r.reports} report)${r.failed ? `, ${r.failed} non riusciti` : ""}`); });
  return (
    <>
    <VigImport />
    <Panel className="mb-6" data-testid="vig-digest-panel">
      <div className="flex items-center justify-between gap-4 mb-4">
        <h3 className="font-semibold text-[var(--navy)] flex items-center gap-2"><Mail className="w-4 h-4" />Riepilogo giornaliero via email</h3>
        <label className="flex items-center gap-2 text-sm">Attivo<Switch checked={c.enabled} onCheckedChange={(v) => set("enabled", v)} data-testid="vig-digest-enabled" /></label>
      </div>
      <div className="grid gap-5 md:grid-cols-[160px_1fr]">
        <div>
          <label className="text-sm text-slate-600">Ora di invio</label>
          <Input type="time" value={c.ora} onChange={(e) => set("ora", e.target.value)} className="h-10 mt-1" data-testid="vig-digest-time" />
        </div>
        <div><label className="text-sm text-slate-600">Destinatari</label><div className="mt-1"><Emails list={c.emails} onChange={(v) => set("emails", v)} /></div></div>
      </div>
      <p className="text-xs text-slate-500 mt-4" data-testid="vig-digest-note">
        {c.ora < "12:00" ? "Con un orario prima delle 12:00 viene inviato il riepilogo della giornata precedente, compreso il turno di notte." : "Viene inviato il riepilogo dei report della giornata in corso."} L'email contiene il testo completo dei report di Vigilanza Fiduciaria e GPG e segnala i turni senza report.
        {d.last_sent && ` Ultimo invio automatico: giornata del ${d.last_sent.split("-").reverse().join("/")}.`}
      </p>
      <div className="flex flex-wrap items-center gap-3 mt-5">
        <Button onClick={save} disabled={!!busy} className="rounded-full bg-[var(--teal)]" data-testid="vig-digest-save">{busy === "save" ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salva"}</Button>
        <span className="text-sm text-slate-500 ml-auto">Invia ora il riepilogo del</span>
        <Input type="date" value={day} max={today()} onChange={(e) => setDay(e.target.value)} className="h-10 w-auto" data-testid="vig-digest-day" />
        <Button variant="outline" onClick={send} disabled={!!busy} className="rounded-full" data-testid="vig-digest-send">{busy === "send" ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4 mr-1" />Invia ora</>}</Button>
      </div>
    </Panel>
    </>
  );
}
